/**
* SeriesGridContainerCard component
* @returns <SeriesGridContainerCard />
*/

import { NavLink } from "react-router-dom"

const SeriesGridContainerCard = ({ item }) => {
    return (
        <NavLink to={item.url ? item.url : "#"} target={item.target ? item.target : "_self"}>
            <div className="series-grid_container_card">
                <p className="series-grid_container_card-title">{item.title}</p>
                <img src={item.image.url} alt={item.title} className="series-grid_container_card-img" />
            </div>
        </NavLink>
    )
}

export default SeriesGridContainerCard